import { render, staticRenderFns } from "./LargeFaceLists.vue?vue&type=template&id=1b7ebe9a&scoped=true"
import script from "./LargeFaceLists.vue?vue&type=script&lang=js"
export * from "./LargeFaceLists.vue?vue&type=script&lang=js"
import style0 from "./LargeFaceLists.vue?vue&type=style&index=0&id=1b7ebe9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ebe9a",
  null
  
)

export default component.exports